export default __webpack_public_path__ + "static/media/arrow-banner.f9d99108.svg";